import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getSettingWebhooksRequest,
  createSettingWebhookRequest,
  updateSettingWebhookRequest,
  deleteSettingWebhookRequest,
} from './webhooksApi';

/*
 * The requests the legacy `WebhookMain`, `WebhookForm` and `WebhookItem` made
 * from inside the components, with their messages. None of them reloads the
 * listing: the slice applies each answer to it, as the legacy did.
 */

const SAVE_ERROR = 'Error al guardar los datos, código esperado 200';

export const fetchWebhooks = createAsyncThunk(
  'webhooks/fetchWebhooks',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await getSettingWebhooksRequest();
      return data;
    } catch (error) {
      console.error(`Fallo al obtener webhooks: ${error?.response || error}`);
      return rejectWithValue(error?.response?.data?.error || 'Error al obtener los datos de webhooks');
    }
  }
);

/**
 * @param {{url: string, status: string, substatus: string, headers: object, body: object}} payload
 */
export const createWebhook = createAsyncThunk(
  'webhooks/createWebhook',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await createSettingWebhookRequest(payload);
      if (!data) return rejectWithValue(SAVE_ERROR);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.setting_webhook || SAVE_ERROR);
    }
  }
);

/**
 * @param {{id: number, payload: object}} params
 */
export const updateWebhook = createAsyncThunk(
  'webhooks/updateWebhook',
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const { data } = await updateSettingWebhookRequest(id, payload);
      if (!data) return rejectWithValue(SAVE_ERROR);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.setting_webhook || SAVE_ERROR);
    }
  }
);

export const deleteWebhook = createAsyncThunk(
  'webhooks/deleteWebhook',
  async (id, { rejectWithValue }) => {
    try {
      const { status } = await deleteSettingWebhookRequest(id);
      if (status >= 200 && status < 300) return id;
      return rejectWithValue('Error al procesar la solicitud');
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || 'Error desconocido');
    }
  }
);
